   <h2 mat-dialog-title>{{ data.title | translate }}</h2>

<mat-dialog-content class="mat-typography">
  <form class="form-wrapper" [formGroup]="firmaZeitForm" autocomplete=off>
    <div class="eineLinie">

      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.mitarbeiterverwaltung.firmaZeitenDialog.jahr' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.mitarbeiterverwaltung.firmaZeitenDialog.jahr' | translate "
          [matDatepicker]="picker"
          formControlName="jahr"
        />
        <mat-datepicker-toggle  [tabIndex]="-1" matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="firmaZeitForm.controls.jahr.invalid">{{ getErrorMessage('jahr') | translate }}</mat-error>
      </mat-form-field>


      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.mitarbeiterverwaltung.firmaZeitenDialog.jahreszeit' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.mitarbeiterverwaltung.firmaZeitenDialog.jahreszeit' | translate"
          formControlName="jahreszeit"
          [decimalNumbersOnlyMax]="3000"
          [kommaStellen]="2"
        />
        <mat-error *ngIf="firmaZeitForm.controls.jahreszeit.invalid">{{ getErrorMessage('jahreszeit') | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.mitarbeiterverwaltung.firmaZeitenDialog.tageszeit' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.mitarbeiterverwaltung.firmaZeitenDialog.tageszeit' | translate"
          formControlName="tageszeit"
          [decimalNumbersOnlyMax]="24"
          [kommaStellen]="2"
        />
        <mat-error *ngIf="firmaZeitForm.controls.tageszeit.invalid">{{ getErrorMessage('tageszeit') | translate }}</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.mitarbeiterverwaltung.firmaZeitenDialog.arbeitstage' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.mitarbeiterverwaltung.firmaZeitenDialog.arbeitstage' | translate"
          formControlName="arbeitstage"
          [decimalNumbersOnlyMax]="365"
          [kommaStellen]="2"
        />
        <mat-error *ngIf="firmaZeitForm.controls.arbeitstage.invalid">{{ getErrorMessage('arbeitstage') | translate }}</mat-error>
      </mat-form-field>
    </div>


  </form>
  <div class="randAbstand">
  <div class="eineLinien">
  <h2 mat-dialog-title>{{ 'pages.mitarbeiterverwaltung.firmaZeitenDialog.feiertage' | translate }}</h2>
  <div class="add-button-container">

    <button (click)="addFeiertage()" matTooltip="Feiertage Hinzufügen"  mat-mini-fab class="pluscolor">
      <mat-icon>add</mat-icon>
    </button>
  </div>
  </div>
  <app-feiertage-table [feiertage]="$feiertage | async"></app-feiertage-table>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    [tabIndex]="-1"
    id="abbruch"
    color="accent"
    (click)="handleCancelClick()"
  >
    {{ data.cancelButtonLabel | translate }}
  </button>
  <button
    mat-raised-button
    color="accent"
    (click)="handleSubmitClick()"
    [disabled]="firmaZeitForm.invalid"
  >
    {{ data.submitButtonLabel | translate }}
  </button>
</mat-dialog-actions>
